import { isProduction } from '@lib/util/site';

const PRODUCTION_API_URL = 'https://us-central1-admin-site-e7397.cloudfunctions.net/qboAPI';
const LOCAL_EMULATOR_URL = 'http://127.0.0.1:5001/admin-site-e7397/us-central1/qboAPI';

/**
 * QBO API Base URL
 * Evaluated lazily on each call so that runtime flags like
 * "Use Production Data in Dev" are always respected, even if the
 * setting was toggled after the module was first imported.
 */
const getApiBaseUrl = () => isProduction() ? PRODUCTION_API_URL : LOCAL_EMULATOR_URL;

export default getApiBaseUrl;
